import { produce } from 'immer';

import { ChangePlaceIdCampaignPlaceEditor } from '../../actions/campaignPlaceEditor/changePlaceIdCampaignPlaceEditor';
import { campaignPlaceEditorPlaceErrors, CampaignPlaceEditorState } from '../../typings/campaignPlaceEditor';

export function changePlaceIdCampaignPlaceEditor(
    state: CampaignPlaceEditorState,
    action: ChangePlaceIdCampaignPlaceEditor
): CampaignPlaceEditorState {
    return produce(state, draft => {
        const { editorId, placeId } = action;
        const editor = draft[editorId];

        draft[editorId].placeId = placeId;

        if (editor.errors) {
            editor.errors = editor.errors.filter(err => {
                return !campaignPlaceEditorPlaceErrors.some(code => {
                    return code === err.code;
                });
            });
        }
    });
}
